"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
function BaseText({ tag, type, className = '', children, ...rest }) {
    const combinedClassName = (0, classnames_1.default)('base-text', type, className);
    const element = (0, react_1.createElement)(tag, { className: combinedClassName, ...rest }, children);
    return element;
}
exports.default = BaseText;
